import { COLORS } from '../constants';
import type { Impact } from '../types';

export function ImpactDot({ impact }: { impact: Impact }) {
  return (
    <span
      title={impact}
      style={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        display: 'inline-block',
        flexShrink: 0,
        background: COLORS.impact[impact] ?? '#ccc',
        boxShadow: impact === 'critical' ? '0 0 6px rgba(209,52,56,0.4)' : 'none',
      }}
    />
  );
}
